/**
 * Novidades (I5) — a página inteira, a partir do arquivo versionado
 * `features/experience/novidades.json`. A gaveta do menu mostra as 5 mais novas; aqui
 * estão todas. Abrir a página também conta como "visto".
 */
import { useEffect } from 'react';
import { Card, PageHeader } from '@mgdlead/ui';

import { ChangelogList } from '../../../features/experience/ChangelogList';
import { useExperience } from '../../../features/experience/ExperienceProvider';
import { useDocumentTitle } from '../../../lib/useDocumentTitle';

export function NovidadesPage() {
  useDocumentTitle('Novidades');
  const { markNewsSeen } = useExperience();

  useEffect(() => {
    markNewsSeen();
  }, [markNewsSeen]);

  return (
    <div className="flex flex-col gap-4">
      <PageHeader
        title="Novidades"
        description="O que mudou no painel, da mais nova para a mais antiga."
      />
      <Card>
        <ChangelogList />
      </Card>
      {/* Página de status: pendência de infra (onde hospedar) — ver docs/product/experiencia-de-uso.md. */}
    </div>
  );
}
